import columns from '../../../../../react-table/helpers/columns';
import {sumTotal, totalRowRatio} from '../../../../../react-table/helpers/rowTotals';

export default (data) => {
  const {
    DateTimeColumn,
    NumberColumn,
    PercentageColumn,
    TextColumn,
    ExternalReportDesatchMonitoringResponsePerformanceColumn,
  } = columns(data);

  return [
    {
      Header: 'Despatch',
      columns: [
        new TextColumn('Origin', 'responsePerformanceRecord.origin')
          .withWidth(85)
          .withTotalHeader('Total'),
        new TextColumn('Destination', 'responsePerformanceRecord.destination')
          .withWidth(85),
        new ExternalReportDesatchMonitoringResponsePerformanceColumn(new TextColumn('ID', 'responsePerformanceRecord.despatchId')),
        new TextColumn('Category', 'responsePerformanceRecord.category'),
        new TextColumn('Mail subclass', 'responsePerformanceRecord.mailSubClass'),
        new DateTimeColumn('Close date', 'responsePerformanceRecord.closeDate'),
      ],
    },
    {
      Header: 'First leg',
      columns: [
        new TextColumn('Conveyance reference', 'responsePerformanceRecord.firstTransportLeg.name'),
        new DateTimeColumn('Planned departure', 'responsePerformanceRecord.firstTransportLeg.scheduledLocalDateTime'),
      ],
    },
    {
      Header: 'Last leg',
      columns: [
        new TextColumn('Conveyance reference', 'responsePerformanceRecord.lastTransportLeg.name'),
        new DateTimeColumn('Planned arrival', 'responsePerformanceRecord.lastTransportLeg.scheduledLocalDateTime'),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new DateTimeColumn('First scan', 'responsePerformanceAggregateRecord.resdesFirstScan'),
        new DateTimeColumn('Last scan', 'responsePerformanceAggregateRecord.resdesLastScan'),
        new TextColumn('Last - First', 'responsePerformanceAggregateRecord.resdesLastFirstDuration'),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Receptacles preadvised', 'responsePerformanceAggregateRecord.receptaclesPreadvised')
          .withTotalHeader(sumTotal),
        new NumberColumn('Receptacles responded', 'responsePerformanceAggregateRecord.receptaclesResponded')
          .withTotalHeader(sumTotal),
        new PercentageColumn('% Responded', 'ratioResponded')
          .withTotalHeader(totalRowRatio(['responsePerformanceAggregateRecord.receptaclesResponded', 'responsePerformanceAggregateRecord.receptaclesPreadvised'])),
        new NumberColumn('Items preadvised', 'responsePerformanceAggregateRecord.itemsPreadvised')
          .withTotalHeader(sumTotal),
        new NumberColumn('Msg', 'responsePerformanceAggregateRecord.msg')
          .withTotalHeader(sumTotal),
      ],
    },
  ];
};
